import Env from '../base/env';
import Component from 'gia/Component';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component
{
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    if(Env.mobileCSS == false) {
      this.makeSticky()
    }

  }

  makeSticky()
  {
    const offsetStart = (Env.mobileCSS)?'top 100px':'top 315px'
    this.sticky = ScrollTrigger.create({
      trigger:this.DOM.view,
      start:offsetStart,
      pin:true,
      pinSpacing:false,
      end: () => ScrollTrigger.maxScroll(document.body),
      invalidateOnRefresh: true,
    })
  }

  unmount()
  {
    this.sticky.kill()
  }
}
